import React, { forwardRef } from 'react';
import { get } from 'lodash';
import { Tag } from 'tuui';
import { TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { STATIC_FILTERS_MAP } from 'modules/campaigns/modules/campaigns-reports/config';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { FilterValues } from '../FilterValues/FilterValues';
import { isComparableFilter, isCompareOperator } from '../filterUtils';
import { comparableFilterValuesResolver } from './comparableFilterValuesResolver';
import styles from './closedFilterUnit.module.scss';

const TagWoTooltip = forwardRef(({ message, ...rest }, ref) => {
    return (
        <Tag {...rest} ref={ref}>
            {message}
        </Tag>
    );
});

const TagWithTooltip = ({ content, ...rest }) => (
    <span>
        <Tooltip arrow interactive>
            {content}
        </Tooltip>
        <TagWoTooltip color="primary" {...rest} />
    </span>
);

export const ClosedFilterUnit = ({ onEditFilter, onRemoveFilter, filter, availableFiltersMap }) => {
    const { type, values, operator } = filter;
    const minVisibleCount = get(availableFiltersMap, `${type}.minVisibleCount`);
    const typeLabel = get(availableFiltersMap, `${type}.label`) || (
        <FormattedMessage id={`app.campaigns.reports.filters.type.${type}`} />
    );
    const listView =
        (!operator?.value || !isCompareOperator(operator?.value)) && !isComparableFilter(STATIC_FILTERS_MAP, type);
    const tooltipMessageIdPrefix = STATIC_FILTERS_MAP[type]?.tooltipMessageIdPrefix;
    const { currency } = useAccount();
    const jointValues = listView
        ? values.map(value => value.label).join(', ')
        : comparableFilterValuesResolver({ type, values, operator, currency, availableFiltersMap });

    const message = listView ? (
        FilterValues({ values, typeLabel, minVisibleCount })
    ) : (
        <span className={styles['filter-value-container']}>
            <FormattedMessage
                id="app.campaigns.reports.filters.comparable.closed.label.withOperator"
                values={{
                    type: typeLabel,
                    values: jointValues,
                    operator: operator.label,
                }}
                defaultMessage="{type} - {operator}: {values}"
            />
        </span>
    );

    const tagProps = {
        onClick: onEditFilter,
        onRemove: onRemoveFilter,
        message,
    };

    if (tooltipMessageIdPrefix && values.length === 1) {
        return (
            <TagWithTooltip
                content={<FormattedMessage id={`${tooltipMessageIdPrefix}.${values[0].value}`} />}
                {...tagProps}
            />
        );
    }

    return <TagWoTooltip {...tagProps} />;
};
